export interface SalespersonOption {
  id: string;
  name: string;
}

export const salespersonOptions: SalespersonOption[] = [
  { id: "adam-meier-poulsen", name: "Adam Meier-Poulsen" },
  { id: "felix-jensen", name: "Felix Jensen" },
  { id: "josefine-bové-hesislev", name: "Josefine Bové Hesislev" },
  { id: "zea-thrams-madsen", name: "Zea Thrams Madsen" }
];
